import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Skeleton } from '@mui/material';
var Loader = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'content' : _b, _c = _a.fieldsCount, fieldsCount = _c === void 0 ? 3 : _c;
    if (type === 'linear') {
        return _jsx(Skeleton, { variant: "rectangular", height: 4 });
    }
    if (type === 'form') {
        return (_jsxs(Box, { children: [Array.from({ length: fieldsCount }).map(function (_, index) { return (_jsx(Skeleton, { variant: "rectangular", height: 56, sx: { mb: 2, borderRadius: 1 } }, index)); }), _jsxs(Box, { sx: { display: 'flex', gap: 2, justifyContent: 'center' }, children: [_jsx(Skeleton, { variant: "rectangular", width: 100, height: 36, sx: { borderRadius: 1 } }), _jsx(Skeleton, { variant: "rectangular", width: 100, height: 36, sx: { borderRadius: 1 } })] })] }));
    }
    return (_jsxs(Box, { children: [_jsx(Skeleton, { variant: "text", height: 40, sx: { mb: 2 } }), _jsx(Skeleton, { variant: "rectangular", height: 120, sx: { mb: 2, borderRadius: 1 } }), _jsx(Skeleton, { variant: "text", height: 24, width: "60%" })] }));
};
export default Loader;
